<template>
  <div id="newsletter" class="container mx-auto">
    <div
      id="mauticform_wrapper_probefahrtanfrage2doubleoptinwmtestcookie"
      class="mauticform_wrapper"
    >
      <form
        autocomplete="false"
        role="form"
        id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie"
        enctype="multipart/form-data"
        @submit.prevent="onFormSubmit"
      >
        <div
          class="mauticform-error"
          id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_error"
        ></div>
        <div
          class="mauticform-message"
          id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_message"
        ></div>
        <div class="mauticform-innerform">
          <div
            class="mauticform-page-wrapper mauticform-page-1"
            data-mautic-form-page="1"
          >
            <div
              id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_kontaktdaten"
              class="mauticform-row mauticform-freetext mauticform-field-1 row col-md-6"
            >
              <h3
                id="mauticform_label_probefahrtanfrage2doubleoptinwmtestcookie_kontaktdaten"
                for="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_kontaktdaten"
                class="mauticform-label"
              >
                Anmeldeformular für den Newsletter
              </h3>
              <div
                id="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_kontaktdaten"
                name="mauticform[kontaktdaten]"
                value=""
                class="mauticform-freetext"
              ></div>
            </div>
            <div
              class="mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6"
              style="width: 100% !important;"
            >
              <div
                id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_vorname"
                class="mauticform-row mauticform-text mauticform-field-3 col-md-6
                      sm:col-span-3"
              >
                <label
                  id="mauticform_label_probefahrtanfrage2doubleoptinwmtestcookie_vorname"
                  for="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_vorname"
                  class="mauticform-label p-0
                        block text-sm font-medium leading-5 text-gray-700"
                >
                  Vorname
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_vorname"
                    v-model="form.firstname"
                    class="mauticform-input
                          form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    type="text"
                    :disabled="loading"
                  />
                </div>
              </div>
              <div
                id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_nachname"
                class="mauticform-row mauticform-text mauticform-field-2 mauticform-required col-md-6
                      sm:col-span-3"
              >
                <label
                  id="mauticform_label_probefahrtanfrage2doubleoptinwmtestcookie_nachname"
                  for="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_nachname"
                  class="mauticform-label p-0
                        block text-sm font-medium leading-5 text-gray-700"
                >
                  Nachname
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_nachname"
                    v-model="form.lastname"
                    class="mauticform-input
                          form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    type="text"
                    :disabled="loading"
                  />
                </div>
                <div v-if="$v.form.lastname.$error">
                  <span
                    v-if="!$v.form.lastname.required"
                    class="mauticform-errormsg
                          text-xs text-red-600"
                  >
                    Bitte geben Sie Ihren Nachnamen ein.</span
                  >
                </div>
              </div>

              <div
                id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_emailadresse"
                class="mauticform-row mauticform-text mauticform-field-4 mauticform-required col-md-6
                      sm:col-span-3"
              >
                <label
                  id="mauticform_label_probefahrtanfrage2doubleoptinwmtestcookie_emailadresse"
                  for="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_emailadresse"
                  class="mauticform-label p-0
                        block text-sm font-medium leading-5 text-gray-700"
                >
                  E-Mail-Adresse
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_emailadresse"
                    v-model="form.email"
                    class="mauticform-input
                          form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    type="text"
                    :disabled="loading"
                  />
                </div>
                <div v-if="$v.form.email.$error">
                  <span
                    v-if="!$v.form.email.required"
                    class="mauticform-errormsg
                          text-xs text-red-600"
                  >
                    Bitte geben Sie eine E-Mail-Adresse ein.</span
                  >
                  <span
                    v-if="!$v.form.email.email"
                    class="mauticform-errormsg
                          text-xs text-red-600"
                  >
                    Bitte geben Sie eine gültige E-Mail-Adresse ein.</span
                  >
                </div>
              </div>
              <div
                id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_postleitzahl1"
                class="mauticform-row mauticform-text mauticform-field-5 mauticform-required col-md-6
                      sm:col-span-3"
              >
                <label
                  id="mauticform_label_probefahrtanfrage2doubleoptinwmtestcookie_postleitzahl1"
                  for="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_postleitzahl1"
                  class="mauticform-label p-0
                        block text-sm font-medium leading-5 text-gray-700"
                >
                  Postleitzahl
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <input
                    id="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_emailadresse"
                    v-model="form.postcode"
                    class="mauticform-input
                          form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    type="text"
                    :disabled="loading"
                  />
                </div>
                <div v-if="$v.form.postcode.$error">
                  <span
                    v-if="!$v.form.postcode.required"
                    class="mauticform-errormsg
                          text-xs text-red-600"
                  >
                    Bitte geben Sie Ihre Postleitzahl an.</span
                  >
                  <span
                    v-if="!$v.form.postcode.maxLength"
                    class="mauticform-errormsg
                          text-xs text-red-600"
                  >
                    Die Postleitzahl darf maximal 5 Ziffern lang sein.</span
                  >
                </div>
              </div>

              <div
                id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_land1"
                class="mauticform-row mauticform-select mauticform-field-7 col-md-6
                    sm:col-span-3"
              >
                <label
                  id="mauticform_label_probefahrtanfrage2doubleoptinwmtestcookie_land1"
                  for="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_land1"
                  class="mauticform-label p-0
                        block text-sm font-medium leading-5 text-gray-700"
                >
                  Land
                </label>
                <div class="mt-1 rounded-md shadow-sm">
                  <select
                    id="mauticform_input_probefahrtanfrage2doubleoptinwmtestcookie_land1"
                    class="mauticform-selectbox
                          form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    v-model="form.countryCode"
                    :disabled="loading"
                  >
                    <option value=""></option>
                    <option value="de">Deutschland</option>
                    <option value="at">Österreich</option>
                    <option value="ch">Schweiz</option>
                  </select>
                </div>
              </div>

              <div
                v-if="!form.isServiceRequest"
                id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_einwilligung_werbung"
                class="mauticform-row mauticform-checkboxgrp mauticform-field-9 mauticform-required full-width
                      sm:col-span-6"
              >
                <div class="mt-2 mauticform-checkboxgrp-row">
                  <label
                    id="mauticform_checkboxgrp_label_einwilligung_werbung_Ja0"
                    for="mauticform_checkboxgrp_checkbox_einwilligung_werbung_Ja0"
                    class="mauticform-checkboxgrp-label"
                  >
                    <input
                      class="mauticform-checkboxgrp-checkbox
                              form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                      id="mauticform_checkboxgrp_checkbox_einwilligung_werbung_Ja0"
                      type="checkbox"
                      v-model="form.agreement"
                    />
                    <span>
                      Durch Angabe meiner E-Mail-Adresse und Anklicken des
                      Buttons „Abonnieren“ erkläre ich mich damit einverstanden,
                      dass die HNF GmbH mir regelmäßig Informationen zu eBikes
                      und Elektromobilität zusendet. Meine Einwilligung kann ich
                      jederzeit gegenüber der HNF GmbH widerrufen.
                    </span>
                  </label>
                  <span
                    v-if="$v.form.agreement.$error"
                    class="mauticform-errormsg
                          text-xs text-red-600"
                  >
                    Bitte bestätigen Sie, dass wir Sie per E-Mail anschreiben
                    dürfen.
                  </span>
                </div>
              </div>

              <div
                id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_einwilligung_werbung"
                class="mauticform-row mauticform-checkboxgrp mauticform-field-9 mauticform-required full-width
                      sm:col-span-6"
              >
                <div class="mt-2">
                  <div
                    id="mauticform_probefahrtanfrage2doubleoptinwmtestcookie_submit"
                    class="mauticform-row mauticform-button-wrapper mauticform-field-15 full-width
                          flex rounded-md shadow-sm"
                  >
                    <button
                      type="button"
                      class="mauticform-button
                        inline-flex items-center justify-center px-6 py-3 w-full border border-transparent text-xs uppercase leading-6 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray active:bg-gray-900 transition ease-in-out duration-150"
                      :disabled="loading"
                      @click="onFormSubmit"
                    >
                      <span v-if="!loading">Abonnieren</span>
                      <span v-else>Anmeldung wird gesendet...</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { required, email, sameAs, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'Newsletter',
  data() {
    return {
      form: {
        firstname: '',
        lastname: '',
        email: '',
        postcode: '',
        countryCode: '',
        utmSource: '',
        utmMedium: '',
        utmCampaign: '',
        utmTimestamp: '',
        agreement: false
      },
      loading: false
    }
  },
  validations: {
    form: {
      lastname: {
        required
      },
      email: {
        required,
        email
      },
      postcode: {
        required,
        maxLength: maxLength(5)
      },
      agreement: {
        sameAs: sameAs(() => true)
      }
    }
  },
  methods: {
    onFormSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const baseUrl =
          process.env.NODE_ENV === 'production'
            ? 'https://ewms.hnf-nicolai.com'
            : 'http://localhost:5000'

        if (!this.form.isServiceRequest) {
          this.getAffiliateCookieData()
        }

        this.loading = true
        axios
          .post(`${baseUrl}/newsletter/subscribe`, this.form)
          .then((res) => {
            if (res.status >= 200 && res.status < 300) {
              window.location.href =
                'https://www.hnf-nicolai.com/checkyourmail/'
            }
          })
          .catch((err) => {
            console.log(err)
            alert(
              'Leider kam es zu einem Fehler in der Übertragung. Bitte versuchen Sie es erneut.'
            )
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    getAffiliateCookieData() {
      if (this.$cookies.get('hnfaffili')) {
        const cookie = this.$cookies.get('hnfaffili')
        this.form.utmSource = cookie.utm_source
        this.form.utmMedium = cookie.utm_medium
        this.form.utmCampaign = cookie.utm_campaign
        this.form.utmTimestamp = cookie.tstamp
      }
    },
    clearFormData() {
      this.form = {
        ...this.form,
        firstname: '',
        lastname: '',
        email: '',
        postcode: '',
        countryCode: '',
        agreement: false
      }
      this.$v.$reset()
    }
  }
}
</script>
